import { render, staticRenderFns } from "./billing-documents-plan-card.vue?vue&type=template&id=5acbc7ab&scoped=true&lang=pug"
import script from "./billing-documents-plan-card.vue?vue&type=script&lang=js"
export * from "./billing-documents-plan-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acbc7ab",
  null
  
)

export default component.exports